/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CittaRes } from '../../models/citta-res';

export interface LuoghiControllerFindManyComuni$Params {}

export function luoghiControllerFindManyComuni(
  http: HttpClient,
  rootUrl: string,
  params?: LuoghiControllerFindManyComuni$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<CittaRes>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindManyComuni.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CittaRes>>;
      }),
    );
}

luoghiControllerFindManyComuni.PATH = '/luoghi/comuni';
